import { Scenario } from '@scenario/models/scenario.model';
import { environment } from '../../../../../environments/environment';
import { ScenarioGateway } from '@scenario/gateways/scenario.gateway';
import {
  formatGetHeaders,
  formatPostHeaders
} from '@configurations/api-configuration';
import { SearchScenariosFormModel } from '@app/scenarios/search-scenarios-form/search-scenarios-form.model';
import { ScenarioMapper } from './scenario.mapper';
import { SearchScenariosMapper } from './search-scenarios.mapper';

export class ApiScenarioGateway implements ScenarioGateway {
  private readonly priceScenariosApi = `${environment.backend_url}/api/v1/scenario`;
  private readonly scenarioMapper = new ScenarioMapper();
  private readonly searchScenariosMapper = new SearchScenariosMapper();

  async retrieveAll(): Promise<Scenario[]> {
    try {
      const response = await fetch(`${this.priceScenariosApi}/search`, await formatGetHeaders());
      const scenarios = await response.json();
      return this.scenarioMapper.mapArrayToModel(scenarios);
    } catch (error) {
      throw new Error('Error retrieving scenarios: ' + error);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async retrieveByFilters(filters: SearchScenariosFormModel): Promise<Scenario[]> {
    try {
      const searchScenariosDTO = this.searchScenariosMapper.mapToDTO(filters);
      const response = await fetch(`${this.priceScenariosApi}/searchWithDTO`, await formatPostHeaders(searchScenariosDTO));
      const scenarios = await response.json();
      return this.scenarioMapper.mapArrayToModel(scenarios);
    } catch (error) {
      throw new Error('Error retrieving scenarios by filters: ' + error);
    }
  }
}
